module.exports = __webpack_public_path__ + "img/icon-404.1a4d6b46.svg";